import store from '@/store'

export default [
  {
    path: '',
    component: () => import('@/components/Layouts/Auth.vue'),
    meta: {
      title: 'Home',
      sort: 6,
      authenticatable: true,
      icon: 'mdi-flask',
    },
    children: [
      {
        path: '',
        props: true,
        name: 'home',
        component: () => import('../Home.vue'),
        meta: {
          title: 'Home',
          sort: 6,
          authenticatable: true,
          icon: 'mdi-flask',
        },
        beforeEnter: (to, from, next) => {
          const isAuthenticated = store.getters['auth/isAuthenticated']

          if (isAuthenticated) {
            return next({name: 'dashboard'})
          } else {
            localStorage.removeItem('user')
            localStorage.removeItem('token')
          }

          return next()
        },
      },
    ],
  }
]
